// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2sp6V","title":"Images90_title__HZZAr","images":"Images90_images__8_Vlq"};